import { InjectionToken } from "@angular/core";

export interface CoreModuleConfig {
    ApiBaseUrl:string;
}

export const CORE_CONFIG = new InjectionToken<CoreModuleConfig>('CoreConfig');
